import colors from 'styles/colors';
import { SVGComponentPropsType } from './types';

const defaultSize = 32;

const ratio = defaultSize / 42;

type PropsType = SVGComponentPropsType & {
  shadow?: boolean;
};

export default ({ color = colors.white, size = defaultSize, shadow = false, ...props }: PropsType) => (
  <svg
    width={`${((size / ratio) * 48) / 42}px`}
    height={`${(size * 38) / defaultSize}px`}
    viewBox={`0 0 48 38`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <filter id="dropshadow" height="130%">
        <feDropShadow dx="0" dy="2" stdDeviation="1" floodColor="black" floodOpacity="0.2" />
      </filter>
    </defs>
    <g id="Dealer" transform={`translate(3, 3)`}>
      <g
        id="Signature-Received"
        transform="translate(-619.000000, -349.000000)"
        stroke={color}
        strokeWidth="6"
        fill="none"
        fillRule="evenodd"
        filter={shadow ? 'url(#dropshadow)' : ''}
      >
        <g id="Group-9" transform="translate(302.000000, 220.000000)">
          <g id="Group-5" transform="translate(285.000000, 91.000000)">
            <polyline id="Path-4" points="35 53.3870968 46.7391304 65 71 41" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
